// Collapse / expand the single post Table of Contents.
//
// Anchor scrolling is handled in CSS (scroll-behavior + scroll-margin-top), so nothing
// here intercepts link clicks - the theme's offcanvas menu, accordions and modal all use
// href="#..." anchors and must keep working.

const TOGGLE_SELECTOR = ".js-single-post-toc-toggle";
const ANIMATION_DURATION = 260;

function animateTocList(listEl, shouldExpand) {
    listEl.classList.add("is-animating");
    listEl.style.transition = "none";

    if (shouldExpand) {
        listEl.hidden = false;

        const expandedHeight = listEl.scrollHeight;
        listEl.style.height = "0px";

        requestAnimationFrame(() => {
            listEl.style.transition = "height " + ANIMATION_DURATION + "ms ease";
            listEl.style.height = expandedHeight + "px";
        });
    } else {
        listEl.style.height = listEl.scrollHeight + "px";

        requestAnimationFrame(() => {
            listEl.style.transition = "height " + ANIMATION_DURATION + "ms ease";
            listEl.style.height = "0px";
        });
    }

    window.setTimeout(() => {
        listEl.hidden = !shouldExpand;
        listEl.style.height = "";
        listEl.style.transition = "";
        listEl.classList.remove("is-animating");
    }, ANIMATION_DURATION + 30);
}

function toggleToc(toggleEl) {
    const controlsId = toggleEl.getAttribute("aria-controls");
    const listEl = controlsId ? document.getElementById(controlsId) : null;

    if (!listEl) {
        return;
    }

    const isExpanded = toggleEl.getAttribute("aria-expanded") === "true";
    toggleEl.setAttribute("aria-expanded", isExpanded ? "false" : "true");
    animateTocList(listEl, !isExpanded);

    const tocSection = toggleEl.closest(".single-post-toc");

    if (tocSection) {
        tocSection.classList.toggle("is-collapsed", isExpanded);
    }
}

// The toggle is a real <button>, so Enter and Space already fire a click - no keydown
// handler needed, and adding one would double-toggle.
document.addEventListener("click", (event) => {
    const toggleEl = event.target.closest(TOGGLE_SELECTOR);

    if (toggleEl) {
        toggleToc(toggleEl);
    }
});
